import CustomerSidebar from './sidebar';

export default CustomerSidebar;
